export const shuffleArray = (array) => {
  array.sort(() => Math.random() - 0.5);
};
